import { AppElement, html } from '../AppElement.js';
import Constants from '../Constants';
import { mapWhatToExpectPickupCompMyPricePNN } from '../StoryPitchMappings.js';

export default class StoryWhatToExpectSubtitle extends AppElement {
    static get properties() {
        return {
            subtitle: { type: String },
            badgeClass: { type: String }
        };
    }

    constructor(props = {}) {
        super();

        this.recordDate = props.recordDate || Constants.MISSING_STR;
        this.stayDate = props.stayDate || Constants.MISSING_STR;
        this.hotel = props.hotel || {};

        this.empty();
    }

    reflow(props = {}) {
        this.recordDate = props.recordDate || Constants.MISSING_STR;
        this.stayDate = props.stayDate || Constants.MISSING_STR;
        this.hotel = props.hotel || {};
        this.fill();
    }

    empty() {
        this.subtitle = Constants.MISSING_STR;
        this.badgeClass = '';
    }

    fill() {
        if (
            typeof this.hotel !== 'object'
            || !this.hotel.id
            || !window.infinito.vao.controller.dateHelper.isDateStr(this.recordDate)
            || !window.infinito.vao.controller.dateHelper.isDateStr(this.stayDate)
        ) {
            this.empty();
            return;
        }

        let modelBiStats = window.infinito.vao.model.biStatistics;
        modelBiStats.fetchStatistics(
            this.hotel.id,
            modelBiStats.buildQuery({
                recordDate: this.recordDate,
                firstStayDate: this.stayDate,
                lastStayDate: this.stayDate,
                fields: [
                    modelBiStats.fields.roomsOtbLeaderCloserTrendProphecy,
                    modelBiStats.fields.compSetAvgLeaderFutureLeaderTrendProphecy,
                    modelBiStats.fields.rateLeaderFutureLeaderTrendProphecy
                ]
            }),
            (data, procData) => {
                let roomsOtbLeaderCloserTrendProphecy =
                    ((procData.roomsOtbLeaderCloserTrendProphecy || {})[this.stayDate] || {}).value || {};
                let compSetAvgLeaderFutureLeaderTrendProphecy =
                    ((procData.compSetAvgLeaderFutureLeaderTrendProphecy || {})[this.stayDate] || {}).value || {};
                let rateLeaderFutureLeaderTrendProphecy =
                    ((procData.rateLeaderFutureLeaderTrendProphecy || {})[this.stayDate] || {}).value || {};

                this.badgeClass = 'badge-primary';

                if (
                    typeof roomsOtbLeaderCloserTrendProphecy === 'object'
                    && 'leadersClosersVariance' in roomsOtbLeaderCloserTrendProphecy
                    && $.isNumeric(roomsOtbLeaderCloserTrendProphecy.leadersClosersVariance)
                    && compSetAvgLeaderFutureLeaderTrendProphecy
                    && typeof compSetAvgLeaderFutureLeaderTrendProphecy === 'object'
                    && 'leaders' in compSetAvgLeaderFutureLeaderTrendProphecy
                    && Array.isArray(compSetAvgLeaderFutureLeaderTrendProphecy.leaders)
                    && 'futureLeaders' in compSetAvgLeaderFutureLeaderTrendProphecy
                    && Array.isArray(compSetAvgLeaderFutureLeaderTrendProphecy.futureLeaders)
                    &&  rateLeaderFutureLeaderTrendProphecy
                    && typeof rateLeaderFutureLeaderTrendProphecy === 'object'
                    && 'leaders' in rateLeaderFutureLeaderTrendProphecy
                    && Array.isArray(rateLeaderFutureLeaderTrendProphecy.leaders)
                    && 'futureLeaders' in rateLeaderFutureLeaderTrendProphecy
                    && Array.isArray(rateLeaderFutureLeaderTrendProphecy.futureLeaders)
                ) {
                    let pickupAnal;
                    let compAnal;
                    let priceAnal;

                    let findMatchingCompFutureLeader = (stayDate) => {
                        return compSetAvgLeaderFutureLeaderTrendProphecy.futureLeaders.find((closer) => {
                            if (closer.stayDate === stayDate) {
                                return true;
                            }
                            return false;
                        });
                    };

                    let findMatchingPriceFutureLeader = (stayDate) => {
                        return rateLeaderFutureLeaderTrendProphecy.futureLeaders.find((closer) => {
                            if (closer.stayDate === stayDate) {
                                return true;
                            }
                            return false;
                        });
                    };

                    if (roomsOtbLeaderCloserTrendProphecy.leadersClosersVariance < 0) {
                        pickupAnal = 'negative';
                    } else if (roomsOtbLeaderCloserTrendProphecy.leadersClosersVariance > 0) {
                        pickupAnal = 'positive';
                    } else {
                        pickupAnal = 'neutral';
                    }

                    // copy pasta
                    let numUp = 0;
                    let ups = [];
                    let numDown = 0;
                    let downs = [];
                    compSetAvgLeaderFutureLeaderTrendProphecy.leaders.forEach((leader) => {
                        let futureLeader = findMatchingCompFutureLeader(leader.stayDate);
                        if (!futureLeader) {
                            return;
                        }
                        let then = leader.value;
                        let now = futureLeader.value;
                        if (!$.isNumeric(then)) {
                            then = Constants.MISSING_STR;
                        }
                        if (!$.isNumeric(now)) {
                            now = Constants.MISSING_STR;
                        }
                        if ($.isNumeric(then) && $.isNumeric(now) && now < then) {
                            numDown++;
                            downs.push(now - then);
                        }
                        if ($.isNumeric(then) && $.isNumeric(now) && now > then) {
                            numUp++;
                            ups.push(now - then);
                        }
                    });
                    // end copy pasta
                    if (numDown === numUp) {
                        compAnal = 'neutral';
                    } else if (numDown > numUp) {
                        compAnal = 'negative';
                    } else {
                        compAnal = 'positive';
                    }

                    // copy pasta
                    numUp = 0;
                    ups = [];
                    numDown = 0;
                    downs = [];
                    rateLeaderFutureLeaderTrendProphecy.leaders.forEach((leader) => {
                        let futureLeader = findMatchingPriceFutureLeader(leader.stayDate);
                        if (!futureLeader) {
                            return;
                        }
                        let then = leader.value;
                        let now = futureLeader.value;
                        if (!$.isNumeric(then)) {
                            then = Constants.MISSING_STR;
                        }
                        if (!$.isNumeric(now)) {
                            now = Constants.MISSING_STR;
                        }
                        if ($.isNumeric(then) && $.isNumeric(now) && now < then) {
                            numDown++;
                            downs.push(now - then);
                        }
                        if ($.isNumeric(then) && $.isNumeric(now) && now > then) {
                            numUp++;
                            ups.push(now - then);
                        }
                    });
                    // end copy pasta
                    if (numDown === numUp) {
                        priceAnal = 'neutral';
                    } else if (numDown > numUp) {
                        priceAnal = 'negative';
                    } else {
                        priceAnal = 'positive';
                    }

                    if (pickupAnal && compAnal && priceAnal) {
                        let combo = pickupAnal + compAnal + priceAnal;
                        let str = mapWhatToExpectPickupCompMyPricePNN[combo] || null;
                        if (str) {
                            this.subtitle = str;
                        } else {
                            this.subtitle = Constants.MISSING_STR;
                        }
                    } else {
                        this.subtitle = Constants.MISSING_STR;
                    }
                } else {
                    this.subtitle = Constants.MISSING_STR;
                }
            }
        );
    }

    firstUpdated(changedProperties) {
        this.fill();
    }

    render() {
        return html`
<div class="${'vao__components--' + this.constructor.name}">
    <vao-story-subtitle subtitle="${this.subtitle}" badgeClass="${this.badgeClass}"></vao-story-subtitle>
</div>
        `;
    }
}

window.vao = window.vao || {};
window.vao.components = window.vao.components || {};
window.vao.components.StoryWhatToExpectSubtitle = StoryWhatToExpectSubtitle;
customElements.define('vao-story-what-to-expect-subtitle', StoryWhatToExpectSubtitle);
